// src/pages/auth/AuthPage.tsx
import React, { useState } from 'react';
import LoginSignupLayout from '../../componants/LoginSignupLayout';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';


const AuthPage: React.FC = () => {
  const [userType, setUserType] = useState<'buyer' | 'seller'>('buyer');
  const [isFlipped, setIsFlipped] = useState(false); // Controls the 3D flip

  return (
    <div className="h-screen w-screen bg-white overflow-hidden">
      <LoginSignupLayout 
        currentUserType={userType} 
        onUserTypeChange={setUserType}
      >
        <div className="perspective-1000 w-full h-full min-h-[450px]">
          <div className={`modal-flipper w-full h-full relative transition-transform duration-700 ${isFlipped ? 'flipped' : ''}`}>
            
            {/* FRONT SIDE - SIGNUP */}
            <div className="modal-front absolute inset-0 w-full h-full bg-white backface-hidden">
              <SignupPage 
                initialUserType={userType} 
                onShowLogin={() => setIsFlipped(true)} 
              />
            </div>

            {/* BACK SIDE - LOGIN */}
            <div className="modal-back absolute inset-0 w-full h-full bg-white backface-hidden rotate-y-180">
              <LoginPage 
                initialUserType={userType} 
                onShowSignup={() => setIsFlipped(false)} 
                onLoginSuccess={() => console.log('Logged In')}
              />
            </div>

          </div>
        </div>
      </LoginSignupLayout>
    </div>
  );
};

export default AuthPage;